import { BACKEND_URL } from "@/lib/api";
import { X, Twitter, HeartHandshake } from "lucide-react";
import Confetti from "@/pages/payment/Confetti";

const fmtSol = (n) => (Number(n) || 0).toLocaleString(undefined, { maximumFractionDigits: 4 });

/** Shareable "I backed this coin" moment shown right after a tip confirms. */
export default function TipperThanks({ coin, sol, onClose }) {
  const coinUrl = `${window.location.origin}/c/${coin.slug}`;
  const text = `I just backed ${coin.name} ($${coin.ticker}) with ${fmtSol(sol)} SOL on @solspurr — real on-chain tips, straight to the creator 🤝`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="tipper-thanks">
      <Confetti />
      <button
        className="absolute inset-0 bg-black/80"
        onClick={onClose}
        aria-label="Close"
        data-testid="tipper-thanks-backdrop"
      />
      <div className="relative border-2 border-[#cfff04] bg-[#121212] max-w-md w-full p-6">
        <button
          onClick={onClose}
          data-testid="tipper-thanks-close"
          className="absolute top-3 right-3 text-[#d0d0d0] hover:text-white"
          aria-label="Close"
        >
          <X size={16} />
        </button>
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#cfff04] mb-2 flex items-center gap-2">
          <HeartHandshake size={12} /> // You backed this coin
        </div>
        <h3 className="font-display font-black text-2xl uppercase tracking-tighter mb-1">
          {fmtSol(sol)} SOL to {coin.name}.
        </h3>
        <p className="text-[#e2e2e2] text-sm mb-4">
          On-chain, verified, straight to the creator. Flex it — backers get the bragging rights.
        </p>
        <img
          src={`${BACKEND_URL}/api/coins/${coin.slug}/card.png?ts=${Date.now()}`}
          alt={`${coin.name} card`}
          data-testid="tipper-thanks-card"
          className="w-full border border-[#3a3a3a] mb-4"
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
        <div className="flex gap-3">
          <a
            href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(coinUrl)}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="tipper-thanks-share"
            className="btn-brutal flex-1 bg-[#1d9bf0] text-white font-bold uppercase tracking-wider text-xs px-4 py-3 inline-flex items-center justify-center gap-2"
          >
            <Twitter size={14} /> Share it
          </a>
          <button
            onClick={onClose}
            data-testid="tipper-thanks-done"
            className="btn-brutal border border-[#333] text-[#e2e2e2] font-bold uppercase tracking-wider text-xs px-4 py-3"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
